/*
  IGO04 - BF Hero Offer: gift bar + gift lines in the Rebuy Smart Cart drawer.
  Markup + config: snippets/igo04-cart-gifts.liquid (rendered once from layout/theme.liquid).
  Spec: IGO04 dev spec v1.5, rules 1 to 11.

  How it decides (every check re-reads /cart.js):
  - gift lines = lines this script added (line property _igo04_gift, set on /cart/add.js), plus
    any line of a tier 1 gift product (the Performance Golf Bonus Pack only exists as a gift). A Strip the
    shopper put in the cart is a normal paid line: it counts toward the thresholds, keeps its
    quantity + remove controls and is never touched; at tier 2 no second Strip is added for it
    (the store's automatic discount makes the one in the cart free).
  - paid lines = every other line; total = their final_line_price summed (BOGOS gift clones
    are $0 and add nothing).
  - excluded line = a paid line whose vendor is in config.excludedVendors, or whose product
    carries config.exclusionTag (tags from Rebuy's item data, else one /products/<handle>.js).
  - any excluded line, or no paid line above $0 => no bar, no gift lines.
  - tier 2 at total >= t2, tier 1 at total >= t1 (cart currency = page currency).
  - config.t2 = 0 (the gate's single tier: the Canada store unless "Tier 2 in Canada" is on)
    = no tier 2: states 1a / 1b / 3 only, one marker, the Strip is never added.
  - gift lines are real cart lines: added with /cart/add.js, removed / reset to 1 with
    /cart/update.js by line key, 0.5 s after the last cart event but at most 1.2 s after the
    first decision (Rebuy fires several events per add and each used to restart the wait: 4-5 s
    before the gifts showed, Ahmad 03.11; the shopper's own add takes ~1.6 s to land with BOGOS
    and Rebuy needs ~1.1 s to render ours, so ~3 s is the floor). While the write runs the drawer root carries
    data-igo04-pending="add" | "remove": the bar reads config.copy.pending with a spinner, the
    gift rows being removed fade (CSS). Rebuy intercepts every cart call, re-renders the drawer
    AND opens it, so lines only change while the drawer is open (or on the /cart page, with one
    reload); a change needed while it is closed waits for the next open. The Strip is a real
    $239.99 product: the store's automatic discount makes it free at tier 2, which also
    guards checkout.
  - a check that finds nothing to do gets one extra cart read 1.5 s later: right after an add,
    /cart.js can still lack the shopper's line and Rebuy may fire nothing else (the gift then
    never came, "didn't add at all" in a client test on 03.11).
  - loop guard: at most 20 gift writes per 2 minutes per page (was 8: a tester who adds and
    removes repeatedly hit it, then nothing happened for up to 2 minutes).
  - drawer rows: gift rows always sit last (CSS order; Shopify puts the newest line first), and a
    gift whose variant title is "a / b / c" (the Bonus Pack's three inclusions as three options)
    gets them on three lines under the title (igo04-gift__includes, Rebuy's own variant title hidden).
  - config.active false (kill switch / after the end date) = remove the gift lines, no bar.
  - GA4 (gtag, send_to G-LHVQZ62JHL): igo04_bar_seen_<state> once per drawer open,
    igo04_tier1_added / igo04_tier2_added when the lines get added.
  Exposes window.__igo04.giftReference(variantId) for the IGO01 drawer code (struck price).
*/
(function () {
  'use strict';

  if (window.IGO04_CART_INIT) return;
  window.IGO04_CART_INIT = true;

  var configEl = document.getElementById('igo04-cart-config');
  var templates = document.getElementById('igo04-cart-templates');
  if (!configEl) return;

  var config;
  try {
    config = JSON.parse(configEl.textContent);
  } catch (e) {
    return;
  }

  var MUTATION_WINDOW_MS = 120000;
  var MUTATION_MAX = 20; // loop guard (writes per window per page)
  var MUTATION_SETTLE_MS = 500; // quiet time after the last cart event before we write
  var MUTATION_MAX_WAIT_MS = 1200; // ... but never later than this after the first pending decision
  var PENDING_TIMEOUT_MS = 6000; // the pending state clears by itself if no cart event follows
  var RECHECK_MS = 1500; // one extra cart read after a "nothing to do" check: a read right after an add can predate it
  var RENDER_DEBOUNCE_MS = 150;
  var RELOAD_KEY = 'igo04:cart-reload';
  var DESKTOP_QUERY = '(min-width: 799px)';
  var GIFT_PROP = '_igo04_gift'; // line property on the lines this script adds (hidden: leading underscore)
  var GIFT_PROPS = {};
  GIFT_PROPS[GIFT_PROP] = '1';

  var debug = (window.__igo04 = window.__igo04 || {});
  debug.cartVersion = '2026-11-03.5';
  debug.events = debug.events || [];
  debug.checks = 0;
  debug.mutations = [];
  debug.lastState = null;

  var single = !(Number(config.t2) > 0); // no tier 2 (gate t2 = 0)
  var gifts = (config.gifts || []).filter(Boolean);
  var giftById = {};
  gifts.forEach(function (gift) {
    giftById[String(gift.variant)] = gift;
  });
  var excludedVendors = (config.excludedVendors || []).map(norm).filter(Boolean);
  var exclusionTag = norm(config.exclusionTag);
  var isCartPage = /^\/([a-z]{2}(-[a-z]{2})?\/)?cart\/?$/i.test(window.location.pathname);

  debug.giftReference = function (variantId) {
    var gift = giftById[String(variantId)];
    return gift ? gift.value || 0 : 0;
  };

  function norm(value) {
    return String(value === null || value === undefined ? '' : value)
      .trim()
      .toLowerCase();
  }

  function ended() {
    var endTs = Number(config.endTs) * 1000;
    return endTs > 0 && Date.now() > endTs;
  }

  function active() {
    return !!config.active && !ended();
  }

  /* ---------- GA4 ---------- */

  var gaQueue = [];
  var gaTimer = null;

  function sendEvent(name, params) {
    window.gtag('event', name, params);
    debug.events.push(name);
  }

  function flushQueue() {
    if (typeof window.gtag !== 'function') return false;
    while (gaQueue.length) {
      var queued = gaQueue.shift();
      sendEvent(queued[0], queued[1]);
    }
    return true;
  }

  function track(name) {
    var payload = { send_to: config.gaId };
    if (typeof window.gtag === 'function') {
      sendEvent(name, payload);
      return;
    }
    gaQueue.push([name, payload]);
    if (gaTimer) return;
    var tries = 0;
    gaTimer = setInterval(function () {
      tries += 1;
      if (flushQueue() || tries >= 40) {
        clearInterval(gaTimer);
        gaTimer = null;
        gaQueue = [];
      }
    }, 500);
  }

  /* ---------- helpers ---------- */

  /* $3,500 for whole amounts, $601.00 otherwise (or always with cents when forced). */
  function money(cents, forceDecimals) {
    var digits = cents % 100 === 0 && !forceDecimals ? 0 : 2;
    try {
      return new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: config.currency || 'USD',
        currencyDisplay: 'narrowSymbol',
        minimumFractionDigits: digits,
        maximumFractionDigits: digits
      }).format(cents / 100);
    } catch (e) {
      return '$' + (cents / 100).toFixed(digits);
    }
  }

  function drawer() {
    return document.getElementById('rebuy-cart');
  }

  function escapeHtml(value) {
    return String(value).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
  }

  function drawerVisible() {
    var el = drawer();
    return !!el && el.classList.contains('is-visible');
  }

  function rebuyItems() {
    try {
      var smartCart = window.Rebuy && window.Rebuy.SmartCart;
      return (smartCart && typeof smartCart.items === 'function' && smartCart.items()) || [];
    } catch (e) {
      return [];
    }
  }

  function tagsOf(product) {
    if (!product || product.tags === undefined || product.tags === null) return null;
    var tags = product.tags;
    return (Array.isArray(tags) ? tags : String(tags).split(',')).map(norm);
  }

  /* Tags per handle: Rebuy's item data first, else one /products/<handle>.js fetch per handle. */
  var tagCache = {};

  function lineTags(line) {
    var items = rebuyItems();
    for (var i = 0; i < items.length; i++) {
      if (String(items[i].variant_id) === String(line.variant_id)) {
        var tags = tagsOf(items[i].product);
        if (tags) return tags;
      }
    }
    var handle = line.handle;
    if (!handle) return [];
    if (tagCache[handle]) return tagCache[handle];
    if (tagCache[handle] === null) return [];
    tagCache[handle] = null;
    var base = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    fetch(base + 'products/' + encodeURIComponent(handle) + '.js', { credentials: 'same-origin' })
      .then(function (response) {
        return response.ok ? response.json() : null;
      })
      .then(function (product) {
        tagCache[handle] = (product && tagsOf(product)) || [];
        scheduleCheck('tags');
      })
      ['catch'](function () {
        tagCache[handle] = [];
      });
    return [];
  }

  /* A gift line: added by this script (line property), or any line of a tier-1 gift product
     (the Bonus Pack only exists as a gift). A Strip the shopper added is a paid line. */
  function isGift(line) {
    var gift = giftById[String(line.variant_id)];
    if (!gift) return false;
    if (line.properties && line.properties[GIFT_PROP]) return true;
    return gift.tier === 1;
  }

  function lineExcluded(line) {
    if (excludedVendors.length && excludedVendors.indexOf(norm(line.vendor)) !== -1) return true;
    if (exclusionTag && lineTags(line).indexOf(exclusionTag) !== -1) return true;
    return false;
  }

  /* ---------- decision ---------- */

  function decide(cart) {
    var lines = cart.items || [];
    var present = [];
    var variantsInCart = [];
    var total = 0;
    var excluded = false;
    var hasPaid = false;

    lines.forEach(function (line) {
      variantsInCart.push(String(line.variant_id));
      if (isGift(line)) {
        present.push(line);
        return;
      }
      total += line.final_line_price || 0;
      if ((line.final_line_price || 0) > 0) hasPaid = true;
      if (lineExcluded(line)) excluded = true;
    });

    var on = active() && cart.currency === config.currency && !excluded && hasPaid;
    var tier = 0;
    if (on && !single && total >= config.t2) tier = 2;
    else if (on && total >= config.t1) tier = 1;

    var state = null;
    if (on) {
      if (total < config.hintFrom) state = '1a';
      else if (total < config.t1) state = '1b';
      else if (!single && total < config.t2) state = '2';
      else state = '3';
    }

    var wanted = gifts.filter(function (gift) {
      return tier >= gift.tier;
    });
    /* A gift is in place when any line of its variant exists: a Strip the shopper added counts
       (the discount makes it free), so no second Strip is added next to it. */
    var toAdd = wanted.filter(function (gift) {
      return variantsInCart.indexOf(String(gift.variant)) === -1;
    });
    /* Gift lines are changed by line key, never by variant: a paid Strip shares the variant. */
    var updates = {};
    var needsUpdate = false;
    var seen = {};
    present.forEach(function (line) {
      var variant = String(line.variant_id);
      var keep = wanted.some(function (gift) {
        return String(gift.variant) === variant;
      });
      if (!keep || seen[variant]) {
        updates[line.key] = 0;
        needsUpdate = true;
        return;
      }
      seen[variant] = true;
      if (line.quantity !== 1) {
        updates[line.key] = 1;
        needsUpdate = true;
      }
    });

    return {
      total: total,
      tier: tier,
      state: state,
      excluded: excluded,
      presentTier1: present.some(function (line) {
        return giftById[String(line.variant_id)].tier === 1;
      }),
      presentTier2: present.some(function (line) {
        return giftById[String(line.variant_id)].tier === 2;
      }),
      toAdd: toAdd,
      updates: needsUpdate ? updates : null,
      needsChange: toAdd.length > 0 || needsUpdate
    };
  }

  /* ---------- gift bar (drawer) ---------- */

  var bar = null;
  var lastRender = null; // { cart, decision } for cheap re-applies after Rebuy re-renders
  var pendingSeen = false; // set at each drawer open, cleared by the first render with a state

  /* Pending state while a gift write runs: 'add' | 'remove' | null (attribute on the drawer root, CSS). */
  var pendingKind = null;
  var pendingTimer = null;

  function setPending(kind) {
    if (pendingTimer) {
      clearTimeout(pendingTimer);
      pendingTimer = null;
    }
    pendingKind = kind || null;
    var root = drawer();
    if (root) {
      if (pendingKind) root.setAttribute('data-igo04-pending', pendingKind);
      else root.removeAttribute('data-igo04-pending');
    }
    if (pendingKind) {
      pendingTimer = setTimeout(function () {
        setPending(null);
        if (lastRender) render(lastRender.cart, lastRender.decision);
      }, PENDING_TIMEOUT_MS);
    }
  }

  function make() {
    if (!templates || !templates.content) return null;
    var node = templates.content.querySelector('.igo04-gift');
    return node ? node.cloneNode(true) : null;
  }

  /* Fill: 0 -> t1 grows to marker 1's centre, t1 -> t2 to marker 2's centre, then 100%.
     Single tier: the one marker sits at marker 2's position, 0 -> t1 grows to it, then 100%. */
  function fillWidth(total) {
    var desktop = window.matchMedia(DESKTOP_QUERY).matches;
    var marker1 = desktop ? config.marker1Desktop : config.marker1Mobile;
    var marker2 = desktop ? config.marker2Desktop : config.marker2Mobile;
    if (single) return total >= config.t1 ? 100 : (total / config.t1) * marker2;
    if (total >= config.t2) return 100;
    if (total >= config.t1) return marker1 + ((total - config.t1) / (config.t2 - config.t1)) * (marker2 - marker1);
    return (total / config.t1) * marker1;
  }

  function copyFor(decision) {
    var template = (config.copy && config.copy[decision.state]) || '';
    if (pendingKind === 'add' && config.copy && config.copy.pending) template = config.copy.pending;
    var diff = decision.state === '1b' ? config.t1 - decision.total : decision.state === '2' ? config.t2 - decision.total : 0;
    return template
      .replace(/\[t1\]/g, money(config.t1))
      .replace(/\[t2\]/g, money(config.t2))
      .replace(/\[diff\]/g, money(diff, true));
  }

  function renderBar(decision) {
    var root = drawer();
    if (!root) return;
    var goal = root.querySelector('[data-rebuy-cart-anchor="goalBox"]');
    if (!goal) return;
    var current = goal.querySelector(':scope > .igo04-gift');

    if (!decision.state) {
      if (current) current.remove();
      bar = null;
      return;
    }

    if (!current) {
      current = make();
      if (!current) return;
    }
    bar = current;
    bar.setAttribute('data-igo04-state', decision.state);
    var text = bar.querySelector('.igo04-gift__text');
    var html = copyFor(decision);
    if (text && text.innerHTML !== html) text.innerHTML = html;
    var fill = bar.querySelector('.igo04-gift__fill');
    if (fill) fill.style.width = Math.max(0, Math.min(100, fillWidth(decision.total))).toFixed(1) + '%';
    bar.classList.toggle('igo04-gift--t1', decision.total >= config.t1);
    bar.classList.toggle('igo04-gift--t2', !single && decision.total >= config.t2);

    /* directly under the IGO01 free-shipping bar; at the top when there is none */
    var fs = goal.querySelector(':scope > .igo01-fs');
    var anchor = fs ? fs.nextSibling : goal.firstChild;
    if (anchor !== bar) goal.insertBefore(bar, anchor);
  }

  /* Bundle gift row: a variant title "a / b / c" (three options) becomes three lines under the title. */
  function applyIncludes(row, line) {
    var info = row.querySelector('.rebuy-cart__flyout-item-info');
    var title = row.querySelector('.rebuy-cart__flyout-item-product-title');
    var current = info && info.querySelector(':scope > .igo04-gift__includes');
    var parts = String(line.variant_title || '')
      .split(' / ')
      .map(function (part) {
        return part.trim();
      })
      .filter(Boolean);
    if (parts.length < 2 || !info || !title) {
      if (current) current.remove();
      return;
    }
    var html = parts.map(escapeHtml).join('<br>');
    if (!current) {
      current = document.createElement('div');
      current.className = 'igo04-gift__includes';
    }
    if (current.innerHTML !== html) current.innerHTML = html;
    if (title.nextSibling !== current) info.insertBefore(current, title.nextSibling);
  }

  /* Gift lines: no quantity control, no remove icon (CSS on data-igo04-gift). */
  /* Rebuy renders the lines in cart order: pair each row with its line (handle class as the check,
     else the next unused line with that handle), so a paid Strip and the gift Strip stay apart. */
  function markGiftLines(cart) {
    var root = drawer();
    if (!root) return;
    var lines = cart.items || [];
    var rows = root.querySelectorAll('li.rebuy-cart__flyout-item');
    var used = [];
    for (var i = 0; i < rows.length; i++) {
      var row = rows[i];
      var line = lines[i];
      if (line && used.indexOf(i) === -1 && row.classList.contains('product-' + line.handle)) {
        used.push(i);
      } else {
        line = null;
        for (var j = 0; j < lines.length; j++) {
          if (used.indexOf(j) === -1 && row.classList.contains('product-' + lines[j].handle)) {
            line = lines[j];
            used.push(j);
            break;
          }
        }
      }
      if (line && isGift(line)) {
        row.setAttribute('data-igo04-gift', '');
        applyIncludes(row, line);
      } else {
        row.removeAttribute('data-igo04-gift');
      }
    }
  }

  var observer = null;
  var observedRoot = null;
  var writing = false;

  function render(cart, decision) {
    lastRender = { cart: cart, decision: decision };
    /* the write landed (the next cart read needs no change): drop the pending state */
    if (pendingKind && !decision.needsChange) setPending(null);
    if (pendingSeen && decision.state && drawerVisible()) {
      pendingSeen = false;
      track('igo04_bar_seen_' + decision.state);
    }
    writing = true;
    if (observer) observer.disconnect();
    try {
      renderBar(decision);
      markGiftLines(cart);
    } catch (e) {}
    writing = false;
    if (observer && observedRoot) observer.observe(observedRoot, { childList: true, subtree: true });
  }

  var reapplyScheduled = false;

  /* Rebuy re-renders the drawer on every cart change and open: put the bar back from the last decision. */
  function observeDrawer() {
    var root = drawer();
    if (!root || root === observedRoot) return;
    observedRoot = root;
    if (observer) observer.disconnect();
    observer = new MutationObserver(function () {
      if (writing || reapplyScheduled) return;
      reapplyScheduled = true;
      window.requestAnimationFrame(function () {
        reapplyScheduled = false;
        if (!lastRender) return;
        var goal = root.querySelector('[data-rebuy-cart-anchor="goalBox"]');
        var missingBar = !!lastRender.decision.state && goal && !goal.querySelector(':scope > .igo04-gift');
        var giftLines = lastRender.cart.items.filter(isGift).length;
        var marked = root.querySelectorAll('li.rebuy-cart__flyout-item[data-igo04-gift]').length;
        if (missingBar || marked !== giftLines) render(lastRender.cart, lastRender.decision);
      });
    });
    observer.observe(root, { childList: true, subtree: true });
  }

  /* ---------- cart mutations ---------- */

  var inFlight = false;
  var deferred = false;
  var mutationTimer = null;

  function mutationAllowed() {
    var now = Date.now();
    debug.mutations = debug.mutations.filter(function (ts) {
      return now - ts < MUTATION_WINDOW_MS;
    });
    return debug.mutations.length < MUTATION_MAX;
  }

  function post(path, body) {
    return fetch(path, {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    }).then(function (response) {
      if (!response.ok) throw new Error(path + ' ' + response.status);
      return response.json();
    });
  }

  function reloadCartPage() {
    var now = Date.now();
    try {
      var last = Number(window.sessionStorage.getItem(RELOAD_KEY)) || 0;
      if (now - last < 15000) return;
      window.sessionStorage.setItem(RELOAD_KEY, String(now));
    } catch (e) {}
    window.location.reload();
  }

  function mutate(decision) {
    if (inFlight || !mutationAllowed()) return;
    inFlight = true;
    debug.mutations.push(Date.now());
    setPending(decision.toAdd.length ? 'add' : 'remove');
    if (lastRender) render(lastRender.cart, lastRender.decision);
    var chain = Promise.resolve();
    if (decision.updates) {
      chain = chain.then(function () {
        return post('/cart/update.js', { updates: decision.updates });
      });
    }
    if (decision.toAdd.length) {
      chain = chain.then(function () {
        return post('/cart/add.js', {
          items: decision.toAdd.map(function (gift) {
            return { id: Number(gift.variant), quantity: 1, properties: GIFT_PROPS };
          })
        });
      });
    }
    chain
      .then(function () {
        var addedTier1 = decision.toAdd.some(function (gift) {
          return gift.tier === 1;
        });
        var addedTier2 = decision.toAdd.some(function (gift) {
          return gift.tier === 2;
        });
        if (addedTier1 && !decision.presentTier1) track('igo04_tier1_added');
        if (addedTier2 && !decision.presentTier2) track('igo04_tier2_added');
      })
      ['catch'](function () {
        setPending(null);
      })
      .then(function () {
        inFlight = false;
        if (isCartPage) reloadCartPage();
        /* Rebuy re-fetches the cart after any cart call and fires rebuy:cart.change: that check finds no diff. */
      });
  }

  /* The cart must have settled (BOGOS, Rebuy) before we write: re-read it right before mutating.
     Debounce with a cap: each cart event restarts the quiet time, but the write happens at most
     MUTATION_MAX_WAIT_MS after the first decision that needed it. */
  var mutationFirstAt = 0;

  function scheduleMutation(reason) {
    if (mutationTimer) clearTimeout(mutationTimer);
    var now = Date.now();
    if (!mutationFirstAt) mutationFirstAt = now;
    var delay = Math.max(50, Math.min(MUTATION_SETTLE_MS, mutationFirstAt + MUTATION_MAX_WAIT_MS - now));
    if (reason === 'show' && deferred) delay = 50;
    mutationTimer = setTimeout(function () {
      mutationTimer = null;
      if (inFlight) {
        scheduleMutation(reason);
        return;
      }
      mutationFirstAt = 0;
      fetchCart().then(function (cart) {
        if (!cart) return;
        var decision = decide(cart);
        render(cart, decision);
        if (!decision.needsChange) return;
        if (isCartPage || drawerVisible() || reason === 'show') {
          deferred = false;
          mutate(decision);
        } else {
          deferred = true;
        }
      });
    }, delay);
  }

  /* ---------- check ---------- */

  function fetchCart() {
    return fetch('/cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then(function (response) {
        return response.ok ? response.json() : null;
      })
      ['catch'](function () {
        return null;
      });
  }

  /* Shopify can answer /cart.js without the line the shopper just added (the add is still landing, or
     the read hits a stale edge): a check right after a Rebuy event may say "nothing to do" and Rebuy may
     fire nothing else. One extra read RECHECK_MS later catches that; 'recheck' never schedules another. */
  var recheckTimer = null;

  function scheduleRecheck() {
    if (recheckTimer) clearTimeout(recheckTimer);
    recheckTimer = setTimeout(function () {
      recheckTimer = null;
      check('recheck');
    }, RECHECK_MS);
  }

  function check(reason) {
    debug.checks++;
    fetchCart().then(function (cart) {
      if (!cart || !cart.items) return;
      var decision = decide(cart);
      debug.lastState = { reason: reason, total: decision.total, tier: decision.tier, state: decision.state, excluded: decision.excluded, needsChange: decision.needsChange };
      /* the shopper sees the pending state from the decision on, not only once the write starts */
      if (decision.needsChange && !pendingKind && (isCartPage || drawerVisible())) {
        setPending(decision.toAdd.length ? 'add' : 'remove');
      }
      render(cart, decision);
      if (decision.needsChange) {
        if (recheckTimer) {
          clearTimeout(recheckTimer);
          recheckTimer = null;
        }
        scheduleMutation(reason);
      } else {
        deferred = false;
        mutationFirstAt = 0;
        if (reason !== 'recheck' && reason !== 'load') scheduleRecheck();
      }
    });
  }

  var checkTimer = null;

  function scheduleCheck(reason) {
    if (checkTimer) clearTimeout(checkTimer);
    checkTimer = setTimeout(function () {
      checkTimer = null;
      check(reason);
    }, RENDER_DEBOUNCE_MS);
  }

  /* ---------- bar seen (once per drawer open) ---------- */

  var wasVisible = false;

  /* Once per drawer open: the state at the open, or (drawer opened by an add, bar not computed yet) the first state rendered while open. */
  function watchOpen() {
    var root = drawer();
    if (!root) return;
    new MutationObserver(function () {
      var visible = root.classList.contains('is-visible');
      if (visible && !wasVisible) {
        wasVisible = true;
        pendingSeen = true;
      } else if (!visible && wasVisible) {
        wasVisible = false;
        pendingSeen = false;
      }
    }).observe(root, { attributes: true, attributeFilter: ['class'] });
    wasVisible = root.classList.contains('is-visible');
  }

  /* ---------- wire up ---------- */

  var ready = false;

  function init() {
    if (ready || !drawer()) return;
    ready = true;
    observeDrawer();
    watchOpen();
  }

  ['rebuy:smartcart.ready', 'rebuy:cart.ready', 'rebuy:cart.change'].forEach(function (name) {
    document.addEventListener(name, function () {
      init();
      scheduleCheck(name);
    });
  });
  document.addEventListener('rebuy:smartcart.show', function () {
    init();
    if (deferred) scheduleMutation('show');
    else scheduleCheck('show');
  });

  init();
  check('load');

  debug.check = function () {
    check('manual');
  };
})();
